"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiBo = void 0;
const Messages = __importStar(require("../../core/Messages"));
const Exceptions_1 = require("../../core/Exceptions");
const ButtplugDeviceProtocol_1 = require("../ButtplugDeviceProtocol");
const Endpoints_1 = require("../Endpoints");
const ButtplugDeviceWriteOptions_1 = require("../ButtplugDeviceWriteOptions");
class LiBoType {
    constructor() {
        this.Name = "Lottie";
        this.VibeCount = 1;
        this.VibeOrder = [0, 1];
    }
}
class LiBo extends ButtplugDeviceProtocol_1.ButtplugDeviceProtocol {
    constructor(aDeviceImpl) {
        super("LiBo", aDeviceImpl);
        this._devInfo = new LiBoType();
        this._hasRunCommand = false;
        this._vibratorSpeed = [0.0, 0.0];
        this.HandleVibrateCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (aMsg.Speeds.length < 1 || aMsg.Speeds.length > this._devInfo.VibeCount) {
                throw new Exceptions_1.ButtplugDeviceException(`Libo devices require VibrateCmd to have at most ` +
                    `${this._devInfo.VibeCount} speed commands, ${aMsg.Speeds.length} sent.`, aMsg.Id);
            }
            const changed = [false, false];
            for (const cmd of aMsg.Speeds) {
                if (!(Math.abs(cmd.Speed - this._vibratorSpeed[cmd.Index]) > 0.001)) {
                    continue;
                }
                changed[cmd.Index] = true;
                this._vibratorSpeed[cmd.Index] = cmd.Speed;
            }
            if (changed[this._devInfo.VibeOrder[0]] || !this._hasRunCommand) {
                let ep = Endpoints_1.Endpoints.Tx;
                if (this._devInfo.VibeCount === 1 && Math.ceil(this._vibratorSpeed[this._devInfo.VibeOrder[0]] * 0x64) === 0) {
                    ep = Endpoints_1.Endpoints.TxMode;
                }
                // Map a 0 - 100% value to a 0 - 0x64 value since 0 * x == 0 this will turn off the vibe if
                // speed is 0.00
                yield this._device.WriteValue(Buffer.from([Math.ceil(this._vibratorSpeed[this._devInfo.VibeOrder[0]] * 0x64)]), new ButtplugDeviceWriteOptions_1.ButtplugDeviceWriteOptions({ Endpoint: ep }));
            }
            if (this._devInfo.VibeCount < 2 || (!changed[this._devInfo.VibeOrder[1]] && this._hasRunCommand)) {
                if (this._devInfo.VibeCount < 2) {
                    this._hasRunCommand = true;
                }
                return new Messages.Ok(aMsg.Id);
            }
            this._hasRunCommand = true;
            // Map a 0 - 100% value to a 0 - 3 value since 0 * x == 0 this will turn off the vibe if
            // speed is 0.00
            yield this._device.WriteValue(Buffer.from([Math.ceil(this._vibratorSpeed[this._devInfo.VibeOrder[1]] * 3)]), new ButtplugDeviceWriteOptions_1.ButtplugDeviceWriteOptions({ Endpoint: Endpoints_1.Endpoints.TxMode }));
            return new Messages.Ok(aMsg.Id);
        });
        this.HandleStopDeviceCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            return yield this.HandleSingleMotorVibrateCmd(new Messages.SingleMotorVibrateCmd(0, aMsg.DeviceIndex, aMsg.Id));
        });
        this.HandleSingleMotorVibrateCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            const speeds = [];
            for (let i = 0; i < this._devInfo.VibeCount; i++) {
                speeds.push(new Messages.SpeedSubcommand(i, aMsg.Speed));
            }
            return yield this.HandleVibrateCmd(new Messages.VibrateCmd(speeds, aMsg.DeviceIndex, aMsg.Id));
        });
        const tmpType = LiBo.DevInfos.get(aDeviceImpl.Name);
        if (tmpType !== undefined) {
            this._devInfo = tmpType;
            this._name = `LiBo ${this._devInfo.Name}`;
        }
        this.MsgFuncs.set(Messages.StopDeviceCmd, this.HandleStopDeviceCmd);
        this.MsgFuncs.set(Messages.SingleMotorVibrateCmd, this.HandleSingleMotorVibrateCmd);
        this.MsgFuncs.set(Messages.VibrateCmd, this.HandleVibrateCmd);
    }
    get MessageSpecifications() {
        return {
            VibrateCmd: { FeatureCount: this._devInfo.VibeCount },
            SingleMotorVibrateCmd: {},
            StopDeviceCmd: {},
        };
    }
}
exports.LiBo = LiBo;
LiBo.DevInfos = new Map([
    [
        "PiPiJing",
        Object.assign(new LiBoType(), {
            Name: "Elle",
            VibeCount: 2,
            VibeOrder: [1, 0],
        }),
    ],
    [
        "XiaoLu",
        Object.assign(new LiBoType(), {
            Name: "Lottie",
            VibeCount: 1,
        }),
    ],
    [
        "SuoYinQiu",
        Object.assign(new LiBoType(), {
            Name: "Karen",
            VibeCount: 0,
        }),
    ],
    [
        "BaiHu",
        Object.assign(new LiBoType(), {
            Name: "LaLa",
            VibeCount: 2,
        }),
    ],
    [
        "LuXiaoHan",
        Object.assign(new LiBoType(), {
            Name: "LuLu",
            VibeCount: 1,
        }),
    ],
    [
        "MonsterPub",
        Object.assign(new LiBoType(), {
            Name: "MonsterPub",
            VibeCount: 1,
        }),
    ],
]);
//# sourceMappingURL=LiBo.js.map